import gql from 'graphql-tag';
export const ADD_USER = gql `
  mutation createCompanyUserMutation($user: AddUserInput!) {
  addUser(input: $user) {
    user {
      id
      firstName
      lastName
      email
      countryCode
      locale
      phone
      addressLine1
      addressLine2
      zipCode
      city
      state
      roles
      personas
    }
  }
}

`;
//# sourceMappingURL=addUser.js.map